import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import productsService from "./productService";

// ===== HARDCODED PRODUCTS (2 per category) =====
const HARDCODED_PRODUCTS = [
  // --- PCs ---
  {
    _id: "hc_pc_001",
    code: "pc-raider-x1",
    name: "Raider X1 Gaming PC",
    price: 2499.99,
    category: "PCs",
    image: "/raider_x1.png",
    description: "High-performance gaming tower with RTX 4090, Intel i9, 64GB DDR5 RAM, and 2TB NVMe SSD. Built for 4K gaming dominance.",
    createdAt: "2026-01-15T10:00:00Z",
  },
  {
    _id: "hc_pc_002",
    code: "pc-phantom-pro",
    name: "Phantom Pro Rig",
    price: 1899.99,
    category: "PCs",
    image: "/phantom_pro.png",
    description: "Sleek mid-tower with RTX 4070 Ti, AMD Ryzen 9, 32GB DDR5, and RGB lighting. The perfect balance of power and style.",
    createdAt: "2026-02-10T10:00:00Z",
  },

  // --- Consoles ---
  {
    _id: "hc_console_001",
    code: "console-nexus-5",
    name: "Nexus 5 Console",
    price: 549.99,
    category: "Consoles",
    image: "/nexus_5.png",
    description: "Next-gen gaming console with 8K support, 2TB SSD, and ray tracing. Includes wireless controller and headset.",
    createdAt: "2026-01-20T10:00:00Z",
  },
  {
    _id: "hc_console_002",
    code: "console-arc-elite",
    name: "Arc Elite Console",
    price: 499.99,
    category: "Consoles",
    image: "/arc_elite.png",
    description: "Compact powerhouse with 4K/120fps gaming, 1TB NVMe, and backward compatibility with 3 generations of games.",
    createdAt: "2026-03-01T10:00:00Z",
  },

  // --- Controllers ---
  {
    _id: "hc_ctrl_001",
    code: "ctrl-viper-wireless",
    name: "Viper Wireless Controller",
    price: 79.99,
    category: "Controllers",
    image: "https://images.unsplash.com/photo-1600080972464-8e5f35f63d08?auto=format&fit=crop&q=80&w=600", // Proper wireless controller photo
    description: "Ultra-responsive wireless controller with hall-effect triggers, customizable buttons, and 40-hour battery life.",
    createdAt: "2026-02-05T10:00:00Z",
  },
  {
    _id: "hc_ctrl_002",
    code: "ctrl-titan-pro",
    name: "Titan Pro Controller",
    price: 129.99,
    category: "Controllers",
    image: "https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?auto=format&fit=crop&q=80&w=600",
    description: "Tournament-grade controller with adjustable stick tension, back paddles, and 1ms wired connection for competitive play.",
    createdAt: "2026-02-20T10:00:00Z",
  },

  // --- Headphones ---
  {
    _id: "hc_hp_001",
    code: "hp-echo-7-1",
    name: "Echo 7.1 Gaming Headset",
    price: 199.99,
    category: "Headphones",
    image: "https://images.unsplash.com/photo-1546435770-a3e426bf472b?auto=format&fit=crop&q=80&w=600", // Wired Over-ear Headset photo
    description: "Immersive 7.1 surround sound headset with noise-cancelling mic, memory foam cushions, and RGB lighting.",
    createdAt: "2026-01-25T10:00:00Z",
  },
  {
    _id: "hc_hp_002",
    code: "hp-stealth-x",
    name: "Stealth X Wireless Headset",
    price: 249.99,
    category: "Headphones",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&q=80&w=600", // Wireless-looking Headset photo (no cables visible)
    description: "Premium wireless headset with lossless audio, 60-hour battery, active noise cancellation, and detachable boom mic.",
    createdAt: "2026-03-10T10:00:00Z",
  },
];

const initialState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  products: { data: HARDCODED_PRODUCTS },
  trendingProducts: HARDCODED_PRODUCTS.slice(0, 4),
  filteredProducts: [],
  product: null,
  message: "",
};

// ===== ORIGINAL API THUNKS (commented out) =====
/*
export const getProducts = createAsyncThunk(
  "products/get",
  async (_, thunkAPI) => {
    try {
      return await productsService.getAllProducts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getProduct = createAsyncThunk(
  "products/getSingle",
  async (code, thunkAPI) => {
    try {
      return await productsService.getProduct(code);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTrendingProducts = createAsyncThunk(
  "products/getTrending",
  async (_, thunkAPI) => {
    try {
      return await productsService.getTrendingProducts();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createProduct = createAsyncThunk(
  "products/create",
  async (productData, thunkAPI) => {
    try {
      return await productsService.addProduct(productData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/update",
  async ({ code, updateData }, thunkAPI) => {
    try {
      return await productsService.updateProduct(code, updateData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "products/delete",
  async (code, thunkAPI) => {
    try {
      return await productsService.deleteProduct(code);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
*/

// ===== HARDCODED REPLACEMENTS (no-op thunks so dispatch calls don't crash) =====
export const getProducts = createAsyncThunk(
  "products/get",
  async () => {
    // Return hardcoded data instead of fetching from API
    return { data: HARDCODED_PRODUCTS };
  }
);

export const getProduct = createAsyncThunk(
  "products/getSingle",
  async (code) => {
    // Find the product from hardcoded data
    const product = HARDCODED_PRODUCTS.find((p) => p.code === code);
    if (!product) throw new Error("Product not found");
    return { data: product };
  }
);

export const getTrendingProducts = createAsyncThunk(
  "products/getTrending",
  async () => {
    // Return first 4 hardcoded products as trending
    return { data: HARDCODED_PRODUCTS.slice(0, 4) };
  }
);

export const createProduct = createAsyncThunk(
  "products/create",
  async () => {
    // No-op for hardcoded mode
    return {};
  }
);

export const updateProduct = createAsyncThunk(
  "products/update",
  async () => {
    // No-op for hardcoded mode
    return {};
  }
);

export const deleteProduct = createAsyncThunk(
  "products/delete",
  async () => {
    // No-op for hardcoded mode
    return {};
  }
);

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = false;
      state.message = "";
    },
    filterBySearch: (state, action) => {
      const searchTerm = action.payload.toLowerCase();
      state.filteredProducts =
        state.products.data?.filter(
          (product) =>
            product.name.toLowerCase().includes(searchTerm) ||
            product.code.toLowerCase().includes(searchTerm)
        ) || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.products = action.payload;
      })
      .addCase(getProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.product = action.payload.data;
      })
      .addCase(getTrendingProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTrendingProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getTrendingProducts.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.isSuccess = true;
        state.trendingProducts = action.payload.data;
      })
      .addCase(createProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(createProduct.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(updateProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateProduct.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(deleteProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteProduct.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
      });
  },
});

export const { reset, filterBySearch } = productSlice.actions;
export default productSlice.reducer;
